export class CustomerLinkRequest {
  customerLinkId: number;
  linkedIds: string;
}
